import { useAuth } from "@/context/AuthContext";
import { today, num } from "@/lib/docOptions";
import { DocDialog } from "@/components/docs/DocDialog";
import { F, Section, PartyFields, PickSelect } from "@/components/docs/Fields";

const empty = (office) => () => ({
  title: "", portfolio_id: null, contract_date: today(), seller: {}, buyer: {},
  broker: { name: office?.company_name || office?.name || "", address: office?.address || "", chamber_no: office?.chamber_reg_no || "", tc: "" },
  property_address: "", property_kind: "", deed_info: "", others: "", sale_price: "", sale_date: "", payment_method: "",
  penalty: "", extra_terms: "", buyer_rate: 3, seller_rate: 3, late_interest: 10, court_city: office?.city || "", arbitration: "",
});

const normalize = (f) => ({ ...f, sale_price: num(f.sale_price), buyer_rate: num(f.buyer_rate) ?? 0, seller_rate: num(f.seller_rate) ?? 0, late_interest: num(f.late_interest) ?? 0 });

export const ContractForm = (props) => {
  const { office } = useAuth();
  return (
    <DocDialog {...props} kind="contracts" heading="Satış sözleşmesi" empty={empty(office)} normalize={normalize}>
      {(f, set) => (
        <>
          <Section title="Emlak komisyoncusu">
            <PartyFields prefix="contract-broker" value={f.broker} onChange={(v) => set({ broker: v })}
              extra={<F label="Oda Sicil No" testid="contract-broker-chamber" value={f.broker?.chamber_no} onChange={(v) => set({ broker: { ...f.broker, chamber_no: v } })} />} />
          </Section>
          <Section title="Satıcı (taşınmaz sahibi)"><PartyFields prefix="contract-seller" value={f.seller} onChange={(v) => set({ seller: v })} /></Section>
          <Section title="Alıcı adayı">
            <PickSelect url="/customers" label="Müşteriden doldur" placeholder="Müşteri seçin" testid="contract-buyer-pick" toLabel={(c) => c.full_name}
              onPick={(c) => set({ buyer: { ...f.buyer, name: c.full_name, phone: c.phone } })} />
            <PartyFields prefix="contract-buyer" value={f.buyer} onChange={(v) => set({ buyer: v })} />
          </Section>
          <Section title="Sözleşmenin konusu">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
              <F label="Tam ve açık adres" className="col-span-2" testid="contract-address" value={f.property_address} onChange={(v) => set({ property_address: v })} />
              <F label="Cinsi" testid="contract-kind" value={f.property_kind} onChange={(v) => set({ property_kind: v })} />
              <F label="Tapu bilgileri" testid="contract-deed-info" value={f.deed_info} onChange={(v) => set({ deed_info: v })} />
              <F label="Diğerleri" className="col-span-2" value={f.others} onChange={(v) => set({ others: v })} />
              <F label="Satış bedeli (TL)" type="number" testid="contract-price" value={f.sale_price} onChange={(v) => set({ sale_price: v })} />
              <F label="Satış tarihi" type="date" testid="contract-sale-date" value={f.sale_date} onChange={(v) => set({ sale_date: v })} />
              <F label="Ödeme şekli" className="col-span-2" value={f.payment_method} onChange={(v) => set({ payment_method: v })} />
              <F label="Sözleşme tarihi" type="date" testid="contract-date" value={f.contract_date} onChange={(v) => set({ contract_date: v })} />
              <F label="Yetkili mahkeme (il)" value={f.court_city} onChange={(v) => set({ court_city: v })} />
            </div>
          </Section>
          <Section title="Şartlar">
            <div className="grid grid-cols-3 gap-2">
              <F label="Alıcı komisyonu %" type="number" testid="contract-buyer-rate" value={f.buyer_rate} onChange={(v) => set({ buyer_rate: v })} />
              <F label="Satıcı komisyonu %" type="number" testid="contract-seller-rate" value={f.seller_rate} onChange={(v) => set({ seller_rate: v })} />
              <F label="Aylık temerrüt faizi %" type="number" value={f.late_interest} onChange={(v) => set({ late_interest: v })} />
            </div>
            <F label="Cezai şart" area value={f.penalty} onChange={(v) => set({ penalty: v })} />
            <F label="Ek şartlar" area value={f.extra_terms} onChange={(v) => set({ extra_terms: v })} />
            <F label="Tahkim anlaşması" area value={f.arbitration} onChange={(v) => set({ arbitration: v })} />
          </Section>
        </>
      )}
    </DocDialog>
  );
};
